import { render, staticRenderFns } from "./store_data.vue?vue&type=template&id=77e4dab1&scoped=true&"
import script from "./store_data.vue?vue&type=script&lang=js&"
export * from "./store_data.vue?vue&type=script&lang=js&"
import style0 from "./store_data.vue?vue&type=style&index=0&id=77e4dab1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e4dab1",
  null
  
)

export default component.exports